import { render } from "./BaseButtonTeal.vue?vue&type=template&id=ca0646ac"
const script = {}
script.render = render

export default script